import React, { useEffect } from 'react';
import theme from '../../../lib/theme';
import styled, { cx, StylesProps } from '../../../lib/styles';
import { cfImage } from '../../../lib/stringUtils';
import pageHeroStyles from './PageHero_styles';
const { mediaSizes } = theme;


export interface PageHeroProps {
	title: string;
	description: string;
	background?: {
		url: string;
		type: string;
    text_colour: string;
	}
}

const PageHero = ({
	title,
	description,
	background,
	styles,
}: PageHeroProps & StylesProps<typeof pageHeroStyles>) => {

	useEffect(() => {
		// console.log('PageHero useEffect', { title, description, background });

		if (background && background.type === 'video') {
			const video = document.createElement('video');
			video.src = background.url;
			video.autoplay = true;
			video.muted = true;
			video.loop = true;
			video.style.position = 'absolute';
			video.style.top = '0';
			video.style.left = '0';
			video.style.width = '100%';
			video.style.height = '100%';
			video.style.objectFit = 'cover';
			const container = document.querySelector(`.${styles.container}`) as HTMLElement;
			if (container) {
				container.style.position = 'relative';
				container.appendChild(video);
			}
		}
	}, [background, styles.container]);

	return (
		<div className={cx('page-hero-wrapper', styles.container)}>
			<div className={cx('page-hero-container', styles.pageHeroWrapper)}>
				{title && (
					<h1 className={cx('page-hero-heading1', styles.heading1)}>
						{title}
					</h1>
				)}
				{description && (
					<div className={cx('page-hero-description', styles.description)}
						dangerouslySetInnerHTML={{ __html: description }}
					/>
				)}
			</div>
		</div>
	)
}

export default styled(pageHeroStyles)(PageHero);